import { LicensedConfigurationResponse } from "@common/types/edge-client-configuration-types";
import { appUrl } from "@src/cloud-connect/feature-toggles/feature-toggles";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";
import TokensExpiredError from "../errors/tokens-expired-error";
import { buildAuthenticationHeaders } from "../util/build-authentication-headers";

const fetchLicensedConfigurations =
  async (): Promise<LicensedConfigurationResponse> => {
    try {
      const res = await fetch(`${appUrl()}/api/licensed-configurations`, {
        method: "POST",
        headers: buildAuthenticationHeaders(),
      });

      if (res.ok) {
        const data: LicensedConfigurationResponse = await res.json();
        if (data !== undefined) {
          return data;
        }
      } else {
        const json = await res.json();
        if (json.message === "Refresh Token is expired") {
          throw new TokensExpiredError("All Tokens Expired");
        } else {
          throw new Error("Server Responded with 500");
        }
      }
    } catch (err) {
      if (err instanceof TokensExpiredError) {
        navigateTo(Route.TOKENS_EXPIRED_ERROR);
      } else if (err instanceof DOMException) {
        return;
      } else {
        navigateTo(Route.SERVER_ERROR);
      }

      throw err;
    }
  };

export default fetchLicensedConfigurations;
